export const PAUSED_ACTIVATION_LIST = "PAUSED_ACTIVATION_LIST";
export const PAUSED_ACTIVATION_LIST_SUCCESSFULL = "PAUSED_ACTIVATION_LIST_SUCCESSFULL";
export const PAUSED_ACTIVATION_LIST_FAILED = "PAUSED_ACTIVATION_LIST_FAILED";